import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface CalendarIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function CalendarIcon({ className, ...props }: CalendarIconProps) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-5', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M10.21 0C10.6105 0.000255372 10.9354 0.324993 10.9355 0.725586V1.35547H11.5645C13.4615 1.35557 14.9996 2.89304 15 4.79004V11.5645C15 13.4618 13.4617 14.9999 11.5645 15H3.43555C1.53827 14.9999 0 13.4618 0 11.5645V4.79004C0.000353518 2.89304 1.53849 1.35557 3.43555 1.35547H4.06445V0.725586C4.06457 0.324993 4.38948 0.000255131 4.79004 0C5.19073 0.000102212 5.51648 0.324898 5.5166 0.725586V1.35547H9.4834V0.725586C9.48352 0.324898 9.80927 0.000102211 10.21 0ZM1.45117 6.87012V11.5645C1.45117 12.6601 2.33997 13.5487 3.43555 13.5488H11.5645C12.66 13.5487 13.5488 12.6601 13.5488 11.5645V6.87012H1.45117ZM3.43555 2.80664C2.34019 2.80674 1.45153 3.69474 1.45117 4.79004V5.41895H13.5488V4.79004C13.5485 3.69474 12.6598 2.80674 11.5645 2.80664H10.9355V3.43555C10.9354 3.83613 10.6105 4.16088 10.21 4.16113C9.80928 4.16103 9.48353 3.83622 9.4834 3.43555V2.80664H5.5166V3.43555C5.51647 3.83622 5.19072 4.16103 4.79004 4.16113C4.38949 4.16088 4.06459 3.83613 4.06445 3.43555V2.80664H3.43555Z" fill="currentColor" />
    </svg>
  );
}
